
function slide5_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var banners = '';
  var cislo = 0;

  slideReset();
  changeBG("bg5");
  $("#menu_top").hide();

  bmcont = jsondata["sl5_txt1"];
  bmcont += '<div class="bigcircle_pos" id="bigcircle_pos_restart"><div class="bigcircle_anim pulsateMEbig"></div><div class="bigcircleRe"></div><div class="bigcircle_over"></div></div><h2>SPUSTIT ZNOVU</h2>';


  /*pocet = jsondata["sl3_menu1"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id="sl3_big'+i+'" class="bmi_big" data-clicked="'+i+'"><div class="bmi_bg_big"></div><div class="bmi_point_big">';
    bmcont += '<i class="icon icon-5"></i>';
    bmcont += '</div><div id="big'+i+'_tt" class="bmitt_big">'+jsondata["sl3_menu1"][i-1]+'</div></div>';
  }
  bmcont += '</div>';
  bmcont += '<div id="sl3_bm2" class="menuLecba">';
  pocet = jsondata["sl3_menu2"].length + 1;
  for (i=1; i<pocet; i++) {
    bmcont += '<div id=\"menuLecba_'+i+'\" class=\"lecba\" data-clicked="'+i+'"><i class=\"icons icon-7_'+i+'\"></i><p class=\"label\">'+jsondata["sl3_menu2"][i-1]+'</p></div>';
  }
  bmcont += '</div>';*/

  bmcont += '<div id="page3" class="arrowL"><i class="arrow-left"></i></div>';

  $("#slide5").html(bmcont);
  $('#slide5').fadeIn(1000);
  bannerReset();

  $("#bigcircle_pos_restart").on("click", function(){
    $("#menu_top").show();
    slide1_anima();
    $('#tmi1').addClass('active');
  });


  $("#page3").on("click", function(){
    bannerReset();
    $("#menu_top").show();
    slide3_anima();
  });

}
